export { default } from "./LocationFilterTrigger";
